import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const PureSupplierRelationshipsSelectionDetailedSupplierFragmentDoc = gql`
  fragment PureSupplierRelationshipsSelectionDetailedSupplier on Supplier {
    id
    name
    businessNumber
    isVerified
    legalEntity
    paperlessMatchString
    owner {
      id
      name
    }
    parent {
      id
      name
    }
    supplierRelationship {
      id
    }
  }
` as unknown as DocumentNode<Types.PureSupplierRelationshipsSelectionDetailedSupplierFragment, unknown>
